import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';

export const PROFILE_IMAGE_UPDATED_AT_KEY = 'mw_profile_image_updated_at';

// One cache key per page load. A key that changes on every render (Date.now()
// per call) gives the same photo a new URL each time, so the browser downloads
// and decodes it again and again; on a long feed that ran iOS Safari out of
// memory and it reloaded the tab.
const PAGE_LOAD_CACHE_KEY = Date.now();

export const getUploadedProfileImageName = (userId: string | null | undefined) => {
  const normalizedUserId = String(userId || '').trim();

  return normalizedUserId ? `${normalizedUserId}.jpg` : '';
};

export const buildProfileImageUrl = (
  image: string | null | undefined,
  cacheKey: string | number | null | undefined = PAGE_LOAD_CACHE_KEY
) => {
  const normalizedImage = String(image || '').trim();

  if (!normalizedImage) {
    return '';
  }

  return `${GET_BASE_URL_IMAGE}/disneyland/images/userimg/${normalizedImage}?v=${encodeURIComponent(
    String(cacheKey || PAGE_LOAD_CACHE_KEY)
  )}`;
};
